import type { SWRMutationConfiguration, SWRMutationResponse } from 'swr/mutation'
import useSWRMutation from 'swr/mutation'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { TopicInterface } from '../types/topic-interface'

interface UseUpdateTopicsOrderOptions {
  communityPath?: string
  config?: SWRMutationConfiguration<TopicInterface[], Error, string, { orderedTopicIds: number[] }>
}

export const useUpdateTopicsOrder = ({
  communityPath,
  config,
}: UseUpdateTopicsOrderOptions): SWRMutationResponse<
  TopicInterface[],
  Error,
  string | null,
  {
    orderedTopicIds: number[]
  }
> => {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.put,
    TopicInterface[],
    { orderedTopicIds: number[] }
  >({
    method: RequestMethodsEnum.put,
  })

  return useSWRMutation(
    communityPath ? `${COMMUNITY_API_PREFIX}/${communityPath}/topic/order` : null,
    adaptFetcherToSWRMutationFn<TopicInterface[], { orderedTopicIds: number[] }>(fetcher),
    config,
  )
}
